var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPostLockOutlineDark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 30,
    viewBox: "0 0 25 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4285 11.1278V7.89466C19.4285 6.07603 18.7059 4.33195 17.4199 3.04599C16.134 1.76003 14.3899 1.03761 12.5713 1.03761C10.7527 1.03761 9.00857 1.76003 7.72261 3.04599C6.43665 4.33195 5.71423 6.07603 5.71423 7.89466V11.1579",
    stroke: "rgba(84, 81, 81, 1)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3159 28.8722H6.76693C5.2554 28.8722 3.80578 28.2717 2.73696 27.2029C1.66815 26.1341 1.06763 24.6844 1.06763 23.1729V16.7217C1.06763 15.2102 1.66815 13.7606 2.73696 12.6917C3.80578 11.6229 5.2554 11.0226 6.76693 11.0226H18.2557C19.7672 11.0226 21.2168 11.6229 22.2856 12.6917C23.3545 13.7606 23.955 15.2102 23.955 16.7217V23.1729C23.959 24.6753 23.368 26.1182 22.3113 27.1862C21.2547 28.2541 19.8182 28.8603 18.3159 28.8722V28.8722Z",
    stroke: "rgba(84, 81, 81, 1)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5714 18.2857V21.624",
    stroke: "rgba(84, 81, 81, 1)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostLockOutlineDark);
export default __webpack_public_path__ + "static/media/post_lock_outline_dark.622c606c8651de2191c7bc642ab68772.svg";
export { ForwardRef as ReactComponent };